import { Box, Skeleton } from "@mui/material";
import Image from "next/image";
import { CSSProperties, useCallback, useState } from "react";

export function MoxieImage({
  imageUrl,
  width = "100%",
  height = "100%",
  alt,
  style,
}: {
  imageUrl: string;
  width?: number | string;
  height?: number | string;
  alt?: string;
  style?: CSSProperties;
}) {
  const [hasImageLoaded, setHasImageLoaded] = useState(false);
  const [imageHasError, setImageHasError] = useState(false);

  const onLoadCompleteCallback = useCallback(() => {
    setHasImageLoaded(true);
  }, [setHasImageLoaded]);

  const onErrorCallback = useCallback(() => {
    setImageHasError(true);
  }, [setImageHasError]);

  return (
    <Box
      sx={{
        position: "relative",
        width,
        height,
      }}
    >
      <Image
        src={imageUrl}
        alt={alt || "Image"}
        fill
        unoptimized
        onLoad={onLoadCompleteCallback}
        onError={onErrorCallback}
        style={{
          objectFit: "cover",
          ...style,
        }}
      />
      {!imageHasError && !hasImageLoaded && (
        <Skeleton
          variant="rectangular"
          width={width}
          height={height}
          sx={{
            ...style,
          }}
        />
      )}
    </Box>
  );
}
